import React from 'react';
import { useEffect, useState, useRef } from "react";
import styled from 'styled-components';
import NavButton from '../../homepage/header-banner/TopNavButton';
import Footer from '../../homepage/footer/Footer'
import Cloudconsult from '../../homepage/consult/cloudconsult';
import Banner from '../../container/Banner/Banner';
import {
    Container, Row, Col
} from 'react-bootstrap';
import { Grid } from '@mui/material';
//import './sidebar.css';
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute";
import CardTable from '../../microservice/components/CardTable';
import config from '../../microservice/components/config-vn';
import Sidebar from '../../container/Sidebar/Sidebar';
import '../../Style/defaultstyle.css';
import CloudConsultCp from '../../homepage/consult/cloudconsult-cp';
import BanneServerApplication from '../../container/Banner/banner-serverApplication';
import DividerComponent from '../../container/Divider/divider';
import useIsMobile from '../../container/Sidebar/useIsMobile';
import BannerPrivateCloud from '../../container/Banner/banner-privateCloud';
import BannerPrivateCloudVN from '../../container/Banner/banner-privateCloud-vn';
import SidebarVN from '../../container/Sidebar/Sidebar-vn';
import HeaderVn from '../../detailpageVN/Page/component/headervn';
import FooterVn from '../../detailpageVN/Page/component/footervn';


const Sysfont = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
`;


// Titlecloudcompute
function LongRunningVN() {
    const isMobile = useIsMobile();

    return (
        <Sysfont className='App'>
            <HeaderVn />
            <BannerPrivateCloudVN />
            <Container className="main-body">
                <Row>
                    <Col md={12} lg={3}>
                        {!isMobile && <SidebarVN />}
                    </Col>
                    <Col md={12} lg={9} className="right-content">
                        {/* {Titlecloudcompute("Long-Running")} */}

                        <BoxContent>
                            <BoxText >
                                <p class="typo-14">Nếu API Method trong ứng dụng khách mất nhiều thời gian để hoàn tất, có thể chạy nó trong nền trên server,</p>
                                <p class="typo-14">Ứng dụng khách sẽ chuyển sang màn hình tiếp theo hoặc thực thi đoạn mã tiếp theo, </p>
                                <p class="typo-14">Có thể thiết kế để trả về trạng thái hoàn thành của tác vụ nền.</p><br></br>
                                <p class="typo-14">Sử dụng Long-running để nhận phản hồi theo thời gian thực một cách bất đồng bộ về trạng thái Operation (hoàn thành/lỗi)</p>
                            </BoxText>
                        </BoxContent>
                        <DividerComponent />
                        {CardTable(
                            "<p class='typo-21 typo-medium typo-black'>Long-running theo mẫu phản hồi yêu cầu bất đồng bộ (Asynchronous Request-Reply) — quy trình thực thi nền bất đồng bộ.</p>", config.tb7_header, config.tb7_content)}

                        <DividerComponent />
                        <BoxContent>
                            <BoxText ><p class="typo-21-sm typo-medium typo-black">Quy trình hoạt động của Long-running</p></BoxText>
                            <ImageWrap src="https://hanbiro.com/assets/images/cloud/en/long-running-1.png"></ImageWrap>
                        </BoxContent>
                        {/* <CloudConsultCp /> */}
                    </Col>
                </Row>
            </Container>


            <FooterVn />
        </Sysfont>
    );
};

const BoxTitle = styled.div`
  text-align: left;
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 20px;
`

const BoxContent = styled.div`
    ${'' /* box-shadow: 0 0.375rem 1.5rem 0 rgb(140 152 164 / 13%);
    border: 1px solid #E7EAF3;
    border-radius: 4px; 
    margin-bottom: 20px;
    margin-top: 20px; */}
    text-align: left;
`

const BoxText = styled.div`
    ${'' /* margin: 5px; */}
    line-height: 2em;
`
const ImageWrap = styled.img`
  width: 100%;
  object-fit: fill;
`

export default LongRunningVN;